export default {
    car: 'Billån',
    carElectric: 'Elbillån',
    carNoInsurance: 'Kaskofritt billån',
    mc: 'MC-lån',
    atv: 'ATV-lån',
    snowmobile: 'Snøscooterlån',
    campingCar: 'Bobillån',
    campingCaravan: 'Campingvognlån',
    boat: 'Båtlån',
    creditLoan: 'Forbrukslån',
    creditCard: 'Kredittkort',
    unknown: 'Ukjent',
};
